import React from "react";
import classNames from "classnames";
import { TriangleIcon } from "@icons";
import styles from "./NavigationMenu.module.scss";

interface Props {
    icon?: React.ReactNode;
    children: React.ReactNode;
    activeIndicator?: boolean;
    disabled?: boolean;
}

export const NavigationItem: React.FC<Props> = ({
    icon,
    children,
    activeIndicator,
    disabled,
}) => (
    <span
        data-testid={`navigation-item-${typeof children === "string" ? children.toLowerCase() : ""}`}
        className={classNames(styles.item, {
            [styles.itemDisabled]: disabled,
        })}
    >
        {icon !== undefined && <span className={styles.icon}>{icon}</span>}
        {children}

        {activeIndicator && (
            <TriangleIcon
                className={classNames(
                    styles.activeIndicator,
                    "icon-color-gray-500",
                )}
            />
        )}
    </span>
);
